module.exports = __webpack_public_path__ + "img/icon-over-solicitudes-libros.22f95e58.svg";